import { config } from "../../../../config";
import yup from "../../../../utils/yup";

export const styleableButtonSchema = yup.object({
  text: yup
    .string()
    .required("Enter some text for the button")
    .max(config.slack.maxBlockLength, "Button text too long."),
  url: yup
    .string()
    .url_or_merge_tag("Enter a link in a valid format (including https://)")
    .required("Enter a link for the button"),
  fullWidth: yup.boolean().default(false),
  format: yup
    .string()
    .oneOf(["", "left", "center", "right", "start", "end", "justify"])
    .default("left"),
  buttonType: yup
    .string()
    .oneOf(["primary_button", "secondary_button"])
    .default(undefined)
    .required("Select a button template"),
});

export type StylableButtonForm = yup.InferType<typeof styleableButtonSchema>;
